import { Box, FormControl, MenuItem, Select } from "@mui/material";
import DropDownIcon from "assets/DropDownIcon";
import { setInnCode } from "components/app/App.slice";
import { filterPage } from "components/common/Filters/FiltersHelper";
import GlobalFilterDescription from "components/common/Filters/GlobalFilterDescription";
import GlobalFilters from "components/common/Filters/GlobalFilters";
import Typography from "components/common/Typography";
import { useLocation } from "react-router-dom";
import { useAppDispatch, useAppSelector } from "redux/hooks";
import { tokens } from "styles/Tokens";
import { DEFAULT_CORP_INNCODE } from "utils/CommonConstants";
import { planTypes } from "utils/Types";
import { clearPlanDetail } from "../planDetails/PlanDetail.slice";
import "./index.scss";

const ITEM_HEIGHT = 48;
const ITEM_PADDING_TOP = 8;

export const Filters = ({ selectedPlanDetail, planType }: any) => {
  const location = useLocation();
  const dispatch = useAppDispatch();

  const innCode = useAppSelector((state: any) => state.app.innCode);
  const isCorp = useAppSelector((state) => state.app.loggedInUserDetails.isCorp);
  const pageName = filterPage.libraryPlanDetailsDisplay;

  const variantPlanFilter =
    planType === planTypes.MyPlans ? (
      <></>
    ) : (
        location?.state?.innCode ? location?.state?.innCode === DEFAULT_CORP_INNCODE : innCode === DEFAULT_CORP_INNCODE
      ) ? (
      <>
        <Box className="filters-header">
          <Box></Box>
          <GlobalFilters
            filterButtonName="Variant Plan Filter"
            page={pageName}
            isInncodeTargetedPlan={selectedPlanDetail?.isTargeted && selectedPlanDetail?.meta?.innCodes?.length}
          />
        </Box>
        <GlobalFilterDescription page={pageName} bgColor={tokens.Text.General.Inverse} />
      </>
    ) : (
      <></>
    );

  const handleOnChange = async (value: string) => {
    dispatch(setInnCode(value));
    localStorage.setItem("innCode", value);
    dispatch(clearPlanDetail());
  };

  const inncodeDropdown =
    planType === planTypes.AllPlans && !location?.state?.hideInncodeDropdown ? (
      <Box className="filters-header">
        <div></div>
        <div className="inncode-dropdown-label-container">
          <Typography variant="body2" color={tokens.Text.General.Secondary}>
            Viewing plan for
          </Typography>
          <FormControl>
            <Select
              className="inncode_dropdown"
              MenuProps={{
                PaperProps: {
                  style: {
                    maxHeight: ITEM_HEIGHT * 4.5 + ITEM_PADDING_TOP,
                    width: 250
                  }
                }
              }}
              IconComponent={DropDownIcon}
              value={innCode}
              onChange={(event) => handleOnChange(event.target.value)}
            >
              {selectedPlanDetail.meta?.planAvailableInncodes
                ?.split(",")
                ?.sort()
                .map((category: string) => {
                  return (
                    <MenuItem value={category}>
                      <Typography variant="body2">{category}</Typography>
                    </MenuItem>
                  );
                })}
            </Select>
          </FormControl>
        </div>
      </Box>
    ) : (
      <></>
    );

  return isCorp ? variantPlanFilter : inncodeDropdown;
};
